export default __webpack_public_path__ + "static/media/keto_diet@3x.cbe5d60c.jpg";